import { webRequest } from '../../client/HttpClient';
import { API } from '../../client/RouteConstants';
import { APIResult } from '../APIResult';
import { buildURL, logAPIErrorToNewrelic } from '../utils';

export const getWishLists = async (allowedToFail: boolean): Promise<APIResult<WishListItem[]>> => {
    const url = buildURL(`${API.WISH_LISTS_WITH_IMAGES_LITE_MODE}`);
    const request: RequestInit = {
        headers: {
            'x-api-client-id': 'add-to-wishlist-esi',
        },
        credentials: 'include',
    };

    const res = await webRequest(url, request, !allowedToFail);

    const result = new APIResult<WishListItem[]>();
    result.showError = false;
    if (!res) {
        logAPIErrorToNewrelic(`getWishLists`, `No response`, {
            response: res,
            result: result,
            errorMessage: result.errorMessage,
            showError: result.showError,
            url: url,
            allowedToFail: allowedToFail,
        });
        return result;
    }

    if (res.ok) {
        result.success = true;
        result.data = ((await res.json()) as WishlistResponse).wishLists;
    } else {
        logAPIErrorToNewrelic(`getWishLists`, `Response Not OK`, {
            ...res,
            result: result,
            errorMessage: result.errorMessage,
            showError: result.showError,
            url: url,
            allowedToFail: allowedToFail,
        });
    }

    return result;
};
